import { accessors } from '../util';
const Types = new Map([
    [
        String,
        (x)=>x.toString()
    ],
    [
        Number,
        (x)=>parseFloat(x)
    ],
    [
        Boolean,
        (x)=>x = x === false ? false : x != null
    ], 
]);
const applyProps = (self, data)=>{
    for (const [key1, value1] of Object.entries(data))if ([
        String,
        Number,
        Boolean
    ].includes(value1)) data[key1] = void 0;
    accessors(self, data, (key)=>{
        const attr = key.toLowerCase();
        return {
            get: ()=>data[key]
            ,
            set (value) {
                self.setAttribute(attr, value);
            }
        };
    });
    return data;
};
export const attrs = (attrs1)=>(superclass)=>{
        const types = new Map();
        const map = new Map();
        for (const [key2, value] of Object.entries(new attrs1())){
            const type = value == null ? Types.get(String) : Types.get(value) ?? Types.get(value?.constructor);
            if (!type) {
                throw new TypeError(`Attribute "${key2}" is not valid type, must be either: String, Number, Boolean, null, undefined`);
            }
            types.set(key2, type);
            map.set(key2.toLowerCase(), key2);
        }
        const observedAttributes = [
            ...map.keys()
        ];
        return class extends superclass {
            static get observedAttributes() {
                return observedAttributes.concat(super.observedAttributes ?? []);
            }
            #data;
            constructor(...args){
                super(...args);
                this.#data = applyProps(this, new attrs1());
            }
            attributeChangedCallback(name, oldValue, newValue) {
                let key;
                if (key = map.get(name)) {
                    const prev = this.#data[key];
                    const next = types.get(key)(newValue);
                    if (!Object.is(prev, next)) {
                        this.#data[key] = next;
                        this.propertyChangedCallback?.(key, prev, next);
                    }
                }
                super.attributeChangedCallback?.(name, oldValue, newValue);
            }
        };
    }
;
